import React, { useEffect, useState } from 'react';
import './NavBar.scss';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { HiOutlineMenuAlt3, HiOutlineX } from 'react-icons/hi';
import { motion, AnimatePresence } from 'framer-motion';
import images from '../../constants/images';

const navLinks = ['home', 'about', 'work', 'skills', 'services', 'testimonials', 'contact'];

const overlayLink = {
	hidden: { y: '110%', opacity: 0 },
	visible: (i) => ({
		y: '0%',
		opacity: 1,
		transition: { delay: 0.08 + i * 0.06, duration: 0.55, ease: [0.16, 1, 0.3, 1] },
	}),
	exit: { y: '60%', opacity: 0, transition: { duration: 0.25, ease: 'easeIn' } },
};

const NavBar = () => {
	const [toggle, setToggle] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 40);
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	useEffect(() => {
		document.body.style.overflow = toggle ? 'hidden' : '';
		return () => {
			document.body.style.overflow = '';
		};
	}, [toggle]);

	return (
		<motion.header
			className={`app__navbar ${scrolled ? 'is-scrolled' : ''}`}
			initial={{ y: -90, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
		>
			<nav className='app__navbar-inner'>
				<a className='app__navbar-logo' href='/' aria-label='Abdul Rafay — home'>
					<img src={images.logo} alt='Abdul Rafay' className='logo' />
				</a>

				<ul className='app__navbar-links'>
					{navLinks.map((item) => (
						<li key={`link-${item}`}>
							<a href={`#${item}`}>{item}</a>
						</li>
					))}
				</ul>

				<div className='app__navbar-actions'>
					<a
						href='https://github.com/Abdul-Rafay-2002'
						target='_blank'
						rel='noreferrer'
						aria-label='GitHub'
					>
						<FaGithub />
					</a>
					<a
						href='https://www.linkedin.com/in/abdul-rafay-3bb521231/'
						target='_blank'
						rel='noreferrer'
						aria-label='LinkedIn'
					>
						<FaLinkedinIn />
					</a>
					<a className='btn btn-gradient nav-cta' href='#contact'>
						Let's Talk
					</a>
				</div>

				<button
					className='app__navbar-toggle'
					aria-label='Open menu'
					onClick={() => setToggle(true)}
				>
					<HiOutlineMenuAlt3 />
				</button>
			</nav>

			<AnimatePresence>
				{toggle && (
					<motion.div
						className='app__navbar-overlay'
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0, transition: { delay: 0.2, duration: 0.3 } }}
						transition={{ duration: 0.35, ease: 'easeOut' }}
					>
						<button
							className='overlay-close'
							aria-label='Close menu'
							onClick={() => setToggle(false)}
						>
							<HiOutlineX />
						</button>

						<ul className='overlay-links'>
							{navLinks.map((item, i) => (
								<li key={item}>
									<motion.a
										href={`#${item}`}
										onClick={() => setToggle(false)}
										custom={i}
										variants={overlayLink}
										initial='hidden'
										animate='visible'
										exit='exit'
									>
										<span className='index'>0{i + 1}</span>
										{item}
									</motion.a>
								</li>
							))}
						</ul>

						<motion.div
							className='overlay-footer'
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0, transition: { delay: 0.55, duration: 0.5 } }}
							exit={{ opacity: 0 }}
						>
							<span className='overlay-tag'>Fullstack Web Developer</span>
							<div className='overlay-socials'>
								<a
									href='https://github.com/Abdul-Rafay-2002'
									target='_blank'
									rel='noreferrer'
									aria-label='GitHub'
								>
									<FaGithub /> GitHub
								</a>
								<a
									href='https://www.linkedin.com/in/abdul-rafay-3bb521231/'
									target='_blank'
									rel='noreferrer'
									aria-label='LinkedIn'
								>
									<FaLinkedinIn /> LinkedIn
								</a>
							</div>
						</motion.div>
					</motion.div>
				)}
			</AnimatePresence>
		</motion.header>
	);
};

export default NavBar;
